{
  "hotelStatic": {
    "checkAvailability": "Consulta la disponibilidad",
    "selectDatesAndGuests": "Selecciona fechas y huéspedes para ver precios",
    "searchAvailability": "Buscar Disponibilidad",
    "aboutDestination": "Sobre el destino"
  },
  "hotelDirectory": {
    "title": "Directorio de Hoteles",
    "subtitle": "Explora nuestra selección de {{count}} hoteles",
    "metaTitle": "Directorio de Hoteles",
    "metaDescription": "Encuentra y reserva hoteles. Explora nuestra colección completa de hoteles organizados por ciudad y popularidad.",
    "searchPlaceholder": "Buscar por nombre o ciudad...",
    "popularTab": "Más populares",
    "byCityTab": "Por ciudad",
    "views": "visitas",
    "hotels": "hoteles",
    "unknownCity": "Otras ubicaciones",
    "noHotels": "No hay hoteles disponibles",
    "noHotelsDescription": "Todavía no tenemos hoteles registrados. Vuelve pronto.",
    "viewAllInCity": "Ver todos en {{city}} ({{count}})",
    "showingOf": "Mostrando {{showing}} de {{total}} hoteles",
    "viewByCity": "Ver por ciudad"
  },
  "common": {
    "loading": "Cargando...",
    "error": "Error",
    "save": "Guardar",
    "saving": "Guardando...",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "back": "Volver",
    "backToHome": "Volver al Inicio",
    "backToResults": "Volver a resultados",
    "next": "Siguiente",
    "search": "Buscar",
    "seeMore": "Ver más",
    "seeLess": "Ver menos",
    "showLess": "Ver menos",
    "more": "más",
    "viewAll": "Ver todo",
    "addToCart": "Añadir al carrito",
    "adding": "Agregando...",
    "reserve": "Reservar",
    "reserveNow": "Reservar Ahora",
    "from": "desde",
    "perNight": "por noche",
    "nights": "noches",
    "night": "noche",
    "adults": "adultos",
    "adult": "adulto",
    "children": "niños",
    "child": "niño",
    "rooms": "habitaciones",
    "room": "habitación",
    "moreRooms": "Ver más habitaciones ({{count}} restantes)",
    "productNotFound": "Producto no encontrado",
    "pageNotFound": "¡Oops! Página no encontrada",
    "home": "Inicio",
    "type": "Tipo",
    "quantity": "Cantidad",
    "decrease": "Disminuir",
    "increase": "Aumentar",
    "total": "Total",
    "discover": "Descubrir",
    "explore": "Explorar",
    "clearFilters": "Limpiar filtros",
    "clearDates": "Limpiar fechas"
  },
  "userMenu": {
    "myAccount": "Mi Cuenta",
    "myProfile": "Mi Perfil",
    "myReservations": "Mis Reservas",
    "adminPanel": "Panel Admin",
    "login": "Iniciar sesión",
    "logout": "Cerrar Sesión",
    "loggedOut": "Sesión cerrada",
    "loggedOutDescription": "Has cerrado sesión correctamente"
  },
  "accessibility": {
    "skipToContent": "Saltar al contenido principal"
  },
  "profile": {
    "title": "Mi Perfil",
    "subtitle": "Gestiona tu información personal y preferencias",
    "personalInfo": "Información Personal",
    "personalInfoDescription": "Actualiza tu información de contacto",
    "emailCannotChange": "El email no se puede cambiar",
    "fullName": "Nombre Completo",
    "fullNamePlaceholder": "Tu nombre completo",
    "phone": "Teléfono",
    "preferredLanguage": "Idioma Preferido",
    "saveChanges": "Guardar Cambios",
    "security": "Seguridad",
    "securityDescription": "Gestiona la seguridad de tu cuenta",
    "password": "Contraseña",
    "lastUpdated": "Última actualización: Hace 30 días",
    "change": "Cambiar",
    "updated": "Perfil actualizado",
    "updatedDescription": "Tus datos han sido guardados correctamente",
    "loadError": "No se pudo cargar el perfil",
    "updateError": "No se pudo actualizar el perfil"
  },
  "myReservations": {
    "title": "Mis Reservas",
    "subtitle": "Consulta el estado y detalles de tus reservas",
    "tabs": {
      "all": "Todas",
      "active": "Activas",
      "history": "Historial"
    },
    "noReservations": "No tienes reservas",
    "noReservationsDescription": "Explora nuestros destinos y empieza a planificar tu aventura",
    "exploreDestinations": "Explorar Destinos",
    "viewDetails": "Ver Detalles",
    "reservationDetails": "Detalles de tu Reserva",
    "reservationNumber": "Número de Reserva",
    "statusLabel": "Estado",
    "date": "Fecha",
    "reservedProducts": "Productos Reservados",
    "notes": "Notas",
    "needHelp": "¿Necesitas ayuda con tu reserva?",
    "contactUs": "Contáctanos",
    "status": {
      "pending_verification": "Pendiente de Verificación",
      "verified": "Verificada",
      "confirmed": "Confirmada",
      "completed": "Completada",
      "cancelled": "Cancelada"
    },
    "statusDescription": {
      "pending_verification": "Tu reserva está siendo verificada por nuestro equipo.",
      "verified": "Tu reserva ha sido verificada y está siendo procesada.",
      "confirmed": "Tu reserva está confirmada. Te enviaremos más detalles pronto.",
      "completed": "Tu reserva ha sido completada. ¡Esperamos que hayas disfrutado!",
      "cancelled": "Esta reserva ha sido cancelada."
    }
  },
  "nav": {
    "home": "Inicio",
    "hotels": "Hoteles",
    "resorts": "Resorts",
    "cars": "Coches",
    "activities": "Actividades",
    "myProfile": "Mi Perfil",
    "myReservations": "Mis Reservas",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "admin": "Admin",
    "aboutUs": "Conócenos"
  },
  "hero": {
    "title": "Descubre Brasil",
    "subtitle": "Playas paradisíacas, selvas exuberantes y ciudades vibrantes te esperan",
    "cta": "Explorar destinos"
  },
  "search": {
    "destination": "Destino",
    "destinationPlaceholder": "¿A dónde quieres ir?",
    "selectDestination": "Seleccionar destino...",
    "searchDestinationMin": "Buscar destino (mín. 3 letras)...",
    "searchingDestinations": "Buscando destinos...",
    "typeMinLetters": "Digite al menos 3 letras para buscar...",
    "noDestinationsFound": "No se encontraron destinos.",
    "checkIn": "Check-in",
    "checkOut": "Check-out",
    "dates": "Fechas de entrada y salida",
    "selectDates": "Seleccionar fechas",
    "guests": "Huéspedes",
    "adults": "Adultos",
    "children": "Niños (0-17 años)",
    "childrenAge": "Edad de los niños",
    "childLabel": "Niño {{number}}",
    "year": "año",
    "years": "años",
    "searchHotels": "Buscar Hoteles",
    "selectDate": "Seleccionar fecha",
    "adultsCount": "{{count}} adulto",
    "adultsCount_plural": "{{count}} adultos",
    "childrenCount": "{{count}} niño",
    "childrenCount_plural": "{{count}} niños",
    "childAge": "Edad del niño {{number}}",
    "recentSearches": "Búsquedas recientes",
    "noResults": "No se encontraron resultados",
    "destinationGuides": "Guías de destino",
    "viewGuide": "Ver guía"
  },
  "hotelDetail": {
    "backToResults": "Volver a resultados",
    "backToResorts": "Volver a resorts",
    "aboutHotel": "Sobre el hotel",
    "translating": "Traduciendo...",
    "showMore": "Ver más",
    "showLess": "Ver menos",
    "location": "Ubicación",
    "clickToViewMap": "Haz clic para ver el mapa interactivo",
    "mapLoadError": "Error al cargar el mapa",
    "servicesAndFacilities": "Servicios e instalaciones",
    "availableRooms": "Habitaciones disponibles",
    "noRooms": "No hay habitaciones disponibles para estas fechas.",
    "moreRooms": "Ver más habitaciones ({{count}} restantes)",
    "lessRooms": "Ver menos habitaciones",
    "adults": "{{count}} adultos",
    "children": "{{count}} niños",
    "night": "noche",
    "nights": "noches",
    "nonRefundable": "No reembolsable",
    "refundable": "Reembolsable",
    "refundableUntil": "Reembolsable hasta {{date}}",
    "hotelInBrazil": "Hotel en Brasil",
    "bestPriceGuaranteed": "Mejor precio garantizado en euros.",
    "bookOnline": "Reserva Online",
    "stars": "estrellas",
    "breakfast": "Desayuno disponible",
    "parking": "Aparcamiento",
    "pool": "Piscina",
    "ourReview": "Nuestra Evaluación",
    "petFriendly": "Acepta mascotas",
    "noPets": "No acepta mascotas",
    "ourPhotos": "Nuestras Fotos",
    "photo": "Foto",
    "recommendedHotel": "Hotel Recomendado",
    "faq": "Preguntas Frecuentes"
  },
  "imageGallery": {
    "noImages": "No hay imágenes disponibles",
    "morePhotos": "+{{count}} fotos",
    "galleryTitle": "Galería de imágenes",
    "thumbnail": "Miniatura {{index}}",
    "mainImage": "imagen principal",
    "imageNumber": "imagen {{number}}",
    "clickToEnlarge": "Click para ampliar",
    "openFullscreen": "Abrir galería en pantalla completa",
    "viewImage": "Ver imagen {{number}}",
    "closeGallery": "Cerrar galería"
  },
  "room": {
    "breakfastIncluded": "Desayuno incluido",
    "allBoardTypes": "Todos los regímenes",
    "withBreakfast": "Con desayuno",
    "withoutBreakfast": "Sin desayuno",
    "allCancellation": "Todas las políticas",
    "onlyRefundable": "Solo reembolsable",
    "onlyNonRefundable": "Solo no reembolsable",
    "showingFiltered": "Mostrando {{filtered}} de {{total}} habitaciones",
    "noRoomsMatchFilter": "Ninguna habitación coincide con los filtros seleccionados"
  },
  "hotels": {
    "title": "Hoteles en Brasil",
    "subtitle": "Desde resorts de lujo hasta acogedoras pousadas. Encuentra el alojamiento perfecto para tu aventura brasileña.",
    "pageTitle": "Hoteles en Brasil - Reserva Online | Fora da Rota",
    "pageTitleWithDestination": "Hoteles en {{destination}} - Reserva Online | Fora da Rota",
    "pageDescription": "Encuentra y reserva los mejores hoteles en Brasil. Desde resorts de lujo hasta pousadas acogedoras. Precios en euros, pago seguro y cancelación flexible.",
    "pageDescriptionWithDestination": "Encuentra y reserva los mejores hoteles en {{destination}}. Compara precios, ve fotos y reserva con cancelación flexible.",
    "searchResults": "Resultados de la búsqueda",
    "viewMap": "Ver mapa",
    "searching": "Buscando hoteles...",
    "searchingSubtitle": "Esto puede tardar unos segundos",
    "searchComplete": "Búsqueda completada",
    "hotelsFound": "Se encontraron {{count}} hoteles",
    "hotelsIn": "Hoteles en {{destination}}",
    "noResults": "No se encontraron hoteles que coincidan con tu búsqueda.",
    "showing": "Mostrando {{count}} de {{total}} hotel(es)",
    "pageOf": "Página {{current}} de {{total}}",
    "fromPerNight": "desde {{price}}/noche",
    "seeDetails": "Ver detalles",
    "breadcrumb": "Hoteles",
    "footerText": "© 2024 Fora da Rota. Encuentra tu próxima aventura en Brasil.",
    "filters": "Filtros",
    "sortBy": "Ordenar por",
    "price": "Precio",
    "rating": "Valoración",
    "stars": "Estrellas",
    "amenities": "Servicios",
    "location": "Ubicación",
    "seeRooms": "Ver habitaciones",
    "selectRoom": "Seleccionar habitación",
    "roomSelected": "Habitación seleccionada",
    "boardType": "Régimen",
    "cancellationPolicy": "Política de cancelación",
    "freeCancellation": "Cancelación gratuita",
    "nonRefundable": "No reembolsable",
    "refundable": "Reembolsable",
    "refundableUntil": "Reembolsable hasta {{date}}",
    "localTaxes": "Impuestos locales",
    "taxesIncluded": "Impuestos incluidos",
    "payAtHotel": "A pagar en el hotel",
    "totalPrice": "Precio total",
    "moreInfo": "Más información del hotel",
    "moreInfoTitle": "Más información del hotel",
    "observations": "Observaciones",
    "viewOnMap": "Ver en mapa",
    "noRoomsAvailable": "No hay habitaciones disponibles"
  },
  "checkout": {
    "selectHotel": "Seleccionar hotel",
    "selectHotelDescription": "Tienes varios hoteles en tu carrito. ¿Cuál quieres consultar?",
    "title": "Finalizar compra",
    "orderSummary": "Resumen del pedido",
    "guestInfo": "Información del huésped",
    "guestInfoSubtitle": "Por favor, completa los datos de todos los huéspedes",
    "buyerInfo": "Información del comprador",
    "firstName": "Nombre",
    "lastName": "Apellidos",
    "email": "Email",
    "phone": "Teléfono",
    "dateOfBirth": "Fecha de Nacimiento",
    "documentType": "Tipo de Documento",
    "documentNumber": "Número de Documento",
    "gender": "Género",
    "male": "Masculino",
    "female": "Femenino",
    "passport": "Pasaporte",
    "nationalId": "DNI/NIE",
    "paymentMethod": "Método de pago",
    "pay": "Pagar",
    "total": "Total",
    "subtotal": "Subtotal",
    "taxes": "Impuestos",
    "taxesIncluded": "Incluidos",
    "validatingPrices": "Validando precios...",
    "priceChanged": "El precio ha cambiado",
    "viewChanges": "Ver cambios",
    "acceptChanges": "Aceptar cambios",
    "removeItem": "Eliminar item",
    "checkInDate": "Fecha de entrada",
    "checkOutDate": "Fecha de salida",
    "checkInTime": "Hora de entrada",
    "checkOutTime": "Hora de salida",
    "verifyingPayment": "Verificando tu pago...",
    "sessionNotFound": "No se encontró el ID de sesión",
    "paymentVerifyError": "Error al verificar el pago",
    "paymentSuccess": "¡Pago Exitoso!",
    "paymentProcessed": "Tu pago ha sido procesado correctamente.",
    "reservationNumber": "Número de Reserva",
    "reservationVerifying": "Tu reserva está siendo verificada por nuestro equipo. Te enviaremos un correo electrónico con la confirmación en las próximas horas.",
    "viewMyReservations": "Ver Mis Reservas",
    "paymentCancelled": "Pago Cancelado",
    "paymentCancelledDescription": "Has cancelado el proceso de pago.",
    "cartItemsStill": "Tus productos siguen en el carrito y puedes continuar cuando estés listo.",
    "retryPayment": "Reintentar Pago",
    "reservationConfirmed": "¡Reserva Confirmada!",
    "totalToPay": "Total a pagar",
    "processingPayment": "Procesando pago...",
    "payNow": "Pagar ahora",
    "doNotClose": "Por favor, no cierres esta página mientras procesamos tu pago.",
    "paymentSecure": "Tu pago está protegido. Al continuar, aceptas nuestros",
    "termsAndConditions": "términos y condiciones",
    "tripSummary": "Resumen de tu Viaje",
    "tripSummarySubtitle": "Revisa los detalles de tu reserva antes de proceder al pago",
    "noDate": "Sin fecha",
    "noDateDefined": "Sin fecha definida",
    "room": "Habitación",
    "beds": "Camas",
    "guests": "Huéspedes",
    "dates": "Fechas",
    "at": "a las",
    "changesDetected": "Se detectaron cambios en este producto. Por favor, revisa y acepta los cambios para continuar.",
    "moreHotelInfo": "Consulte más información del hotel",
    "yourData": "Tus Datos",
    "street": "Calle",
    "streetNumber": "Número",
    "city": "Ciudad",
    "state": "Provincia/Estado",
    "zipCode": "Código Postal",
    "acceptedPaymentMethods": "Métodos de pago aceptados",
    "cards": "Tarjetas",
    "securePayment": "Pago seguro procesado por Stripe",
    "paymentDetails": "Datos de pago",
    "secure": "Seguro",
    "preparingPayment": "Preparando pago...",
    "validating": "Validando...",
    "completeGuestData": "Completa los datos de los huéspedes",
    "continueToPayment": "Continuar al pago",
    "validatingAvailability": "Estamos validando la disponibilidad y precio de tus productos",
    "completeAllGuestData": "Por favor completa los datos de todos los huéspedes para continuar",
    "byContinuing": "Al continuar, aceptas nuestros",
    "privacyPolicy": "política de privacidad",
    "and": "y las",
    "hotelRules": "reglas del hotel",
    "guestDataComplete": "Datos de los huéspedes completos",
    "completeGuestDataAction": "Completar datos de los huéspedes",
    "guestData": "Datos de los Huéspedes",
    "saving": "Guardando...",
    "copyMyData": "Copiar mis datos",
    "copyFromFirstProduct": "Copiar huéspedes del primer producto",
    "guest": "Huésped",
    "childOfAge": "Niño de {{age}} años",
    "saveGuest": "Guardar",
    "previousDataDetected": "Detectamos datos previos para este huésped",
    "autocomplete": "Autocompletar",
    "selectDate": "Selecciona fecha",
    "adultMinAge": "El adulto debe tener al menos 18 años en la fecha de check-in",
    "childAgeMismatch": "La edad no coincide con la búsqueda ({{age}} años)",
    "sex": "Sexo",
    "dni": "DNI",
    "dataCopied": "Datos copiados",
    "guestDataAutocompleted": "Los datos del huésped han sido completados automáticamente",
    "yourDataCopied": "Tus datos han sido copiados al primer huésped",
    "guestsCopied": "Huéspedes copiados",
    "guestsFromFirstCopied": "Los huéspedes del primer producto han sido copiados",
    "incompleteData": "Datos incompletos",
    "completeYourData": "Por favor completa todos tus datos",
    "completeBuyerData": "Por favor completa todos tus datos de comprador",
    "completeAllGuests": "Por favor completa los datos de todos los huéspedes",
    "completeGuestBeforeSave": "Por favor completa todos los datos del huésped antes de guardar",
    "completeNameFirst": "Por favor completa tu nombre y apellido primero",
    "updated": "Actualizado",
    "productUpdated": "El producto ha sido actualizado con las nuevas condiciones",
    "updateError": "Hubo un problema al actualizar el producto",
    "emptyCart": "Carrito vacío",
    "emptyCartDescription": "Tu carrito está vacío. Agrega productos para continuar.",
    "pendingValidation": "Validación pendiente",
    "waitValidation": "Por favor espera mientras validamos la disponibilidad de los productos",
    "paymentError": "No se pudo obtener los datos de pago.",
    "cancellationPolicies": "Políticas de Cancelación",
    "cancellationSummary": "Resumen de cancelación",
    "initiatePaymentError": "No se pudo iniciar el pago. Intenta de nuevo.",
    "paymentVerifyProblem": "Hubo un problema al verificar el pago. Por favor contacta soporte."
  },
  "cart": {
    "title": "Carrito",
    "empty": "Tu carrito está vacío",
    "emptySubtitle": "Añade productos para comenzar tu reserva",
    "continueShopping": "Continuar comprando",
    "goToCheckout": "Ir al checkout",
    "itemAdded": "Producto añadido al carrito",
    "itemAddedDescription": "El producto se agregó correctamente al carrito",
    "itemRemoved": "Producto eliminado del carrito",
    "itemRemovedDescription": "El producto se eliminó del carrito",
    "items": "{{count}} producto",
    "items_plural": "{{count}} productos",
    "timeRemaining": "Tiempo restante",
    "productsWithChanges": "{{count}} productos con cambios detectados",
    "updating": "Actualizando...",
    "updateAll": "Actualizar Todo",
    "updated": "Actualizado",
    "updatedDescription": "{{count}} producto(s) actualizado(s) con las nuevas condiciones",
    "updateError": "Hubo un problema al actualizar los productos",
    "validatingAvailability": "Validando disponibilidad y precio...",
    "changesDetected": "Se detectaron cambios en este producto",
    "viewChanges": "Ver Cambios",
    "validationDialogTitlePriceIncrease": "Cambios en la reserva",
    "validationDialogTitleInfoUpdated": "Información actualizada",
    "validationDialogIntro": "Las siguientes informaciones de tu reserva han cambiado desde la búsqueda inicial:",
    "validationDialogField": "Campo",
    "validationDialogOldValue": "Valor anterior",
    "validationDialogNewValue": "Valor actual",
    "validationDialogQuestion": "¿Deseas mantener este producto en tu carrito con las nuevas condiciones o prefieres eliminarlo?",
    "validationDialogRemove": "Eliminar del carrito",
    "validationDialogKeep": "Mantener en el carrito",
    "retry": "Reintentar",
    "dates": "Fechas",
    "cancellation": "Cancelación",
    "roomNotAvailable": "Habitación no disponible",
    "roomNotAvailableDescription": "Esta habitación ya no está disponible. Se ha eliminado del carrito.",
    "notAvailable": "Este producto ya no está disponible",
    "validationError": "Error al validar. Por favor, intenta de nuevo.",
    "cannotValidate": "No se pudo validar - token de búsqueda no disponible",
    "cartMigrated": "Carrito migrado",
    "cartMigratedDescription": "Tu carrito de invitado se ha transferido a tu cuenta",
    "itemNotFound": "Item no encontrado",
    "cannotValidateItem": "Este item no puede ser validado",
    "tokenNotAvailable": "Token no disponible",
    "tokenNotAvailableDescription": "No se puede validar sin el token de búsqueda. Por favor, elimina y vuelve a agregar el item.",
    "validationStarted": "Validación iniciada",
    "validationStartedDescription": "Verificando disponibilidad y precio...",
    "expirationWarning": "Tu carrito va a expirar",
    "expirationWarningDescription": "Faltan menos de 3 minutos para que algunos productos expiren. Completa tu compra o los precios deberán ser revalidados.",
    "itemsExpired": "Productos expirados",
    "singleItemExpiredTitle": "Este producto ha expirado",
    "singleItemExpiredDescription": "El precio de \"{{name}}\" necesita ser revalidado.",
    "multipleItemsExpiredTitle": "{{count}} productos han expirado",
    "multipleItemsExpiredDescription": "Los siguientes productos necesitan revalidación de precio:",
    "expiredItemsAction": "¿Qué deseas hacer con estos productos?",
    "removeItem": "Eliminar",
    "removeAllItems": "Eliminar todos",
    "revalidateItem": "Revalidar precio",
    "revalidateAllItems": "Revalidar todos",
    "revalidating": "Revalidando...",
    "sessionAbandoned": "Sesión inactiva",
    "sessionAbandonedDescription": "Tu sesión ha estado inactiva por 2 minutos. ¿Deseas continuar comprando?"
  },
  "auth": {
    "login": "Iniciar sesión",
    "register": "Registrarse",
    "email": "Email",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "noAccount": "¿No tienes cuenta? Regístrate",
    "hasAccount": "¿Ya tienes cuenta? Inicia sesión",
    "orContinueWith": "O continúa con",
    "loginDescription": "Accede a tu cuenta",
    "registerDescription": "Regístrate para comenzar",
    "loginSuccess": "Inicio de sesión exitoso",
    "signupSuccess": "Cuenta creada exitosamente"
  },
  "footer": {
    "company": "Empresa",
    "aboutUs": "Quiénes Somos",
    "contact": "Contacto",
    "support": "Soporte",
    "faq": "Preguntas Frecuentes",
    "helpCenter": "Centro de Ayuda",
    "legal": "Legal",
    "terms": "Términos y Condiciones",
    "privacy": "Política de Privacidad",
    "followUs": "Síguenos",
    "rights": "Todos los derechos reservados",
    "popularHotels": "Hoteles Populares",
    "seeMoreHotels": "Ver más hoteles",
    "photoCredits": "Créditos de fotos",
    "unsplashLicense": "Imágenes bajo licencia Unsplash - uso gratuito con atribución apreciada",
    "popularDestinations": "Destinos populares"
  },
  "destinations": {
    "title": "Destinos populares",
    "subtitle": "Explora los lugares más increíbles de Brasil"
  },
  "success": {
    "title": "¡Pago completado!",
    "subtitle": "Tu reserva ha sido confirmada",
    "reservationNumber": "Número de reserva",
    "emailSent": "Te hemos enviado un email con los detalles",
    "backHome": "Volver al inicio"
  },
  "errors": {
    "generic": "Ha ocurrido un error. Por favor, inténtalo de nuevo.",
    "notFound": "Página no encontrada",
    "unauthorized": "No autorizado",
    "paymentFailed": "El pago ha fallado",
    "searchFailed": "No se pudieron buscar hoteles. Por favor, intenta de nuevo."
  },
  "seo": {
    "homeTitle": "Fora da Rota | Viajes Únicos a Brasil",
    "homeDescription": "Descubre Brasil con Fora da Rota. Hoteles, resorts y experiencias auténticas en los mejores destinos brasileños.",
    "hotelsTitle": "Hoteles en Brasil | Fora da Rota",
    "hotelsDescription": "Reserva hoteles en Brasil. Resorts de lujo y posadas con encanto en los mejores destinos.",
    "resortsTitle": "Resorts All Inclusive en Brasil | Fora da Rota",
    "resortsDescription": "Los mejores resorts all inclusive de Brasil. Costa do Sauípe, Caribe, África y más."
  },
  "faq": {
    "title": "Preguntas Frecuentes",
    "subtitle": "Encuentra respuestas a las dudas más comunes sobre reservas, pagos, cancelaciones y más.",
    "pageTitle": "Preguntas Frecuentes (FAQ) - Fora da Rota",
    "pageDescription": "Encuentra respuestas a las preguntas más frecuentes sobre reservas, pagos y cancelaciones en Fora da Rota.",
    "notFound": "¿No encontraste lo que buscabas?",
    "notFoundSubtitle": "Nuestro equipo está listo para ayudarte con cualquier duda.",
    "sections": {
      "content": {
        "title": "Sobre Nuestro Contenido",
        "howKnow": {
          "q": "¿Cómo Fora da Rota conoce los destinos?",
          "a": "Juntamos las experiencias de viajes de nuestro equipo, el conocimiento de nuestros socios locales y visitas presenciales para conseguir construir el mejor contenido para ti."
        },
        "updated": {
          "q": "¿Las informaciones de los destinos están actualizadas?",
          "a": "Intentamos al máximo mantener todo actualizado, pero por ser un contenido hecho a mano puede suceder que tenga alguna información desactualizada. Revisamos periódicamente nuestras indicaciones para evitar que eso suceda."
        },
        "problem": {
          "q": "Encontré un problema en el sitio o me gustaría enviar una sugerencia, ¿cómo hago?",
          "a": "Primero, muchas gracias por tu tiempo y dedicación de informarnos una mejora o corrección, ¡estamos muy felices de tener visitantes como tú! Envía tu sugerencia o problema encontrado a contato@foradarota.com y explícanos qué sucedió y qué pasos hiciste en el sitio para que podamos corregir y mejorar."
        },
        "notFoundDest": {
          "q": "Estoy buscando un destino y no lo encontré, ¿qué hacer?",
          "a": "Vaya, no conseguimos registrar todos los destinos aún, pero estamos trabajando para aumentar el número de destinos disponibles. ¡Envíanos el destino que estás buscando a contato@foradarota.com que te vamos a ayudar!"
        },
        "offers": {
          "q": "¿Cómo puedo encontrar ofertas y promociones especiales?",
          "a": "¡Estate atento a nuestras redes sociales y al sitio! Siempre tenemos ofertas increíbles y promociones exclusivas para nuestros clientes. ¡Ah, y puedes registrarte en nuestra newsletter para recibir todo en primera mano!"
        }
      },
      "reservations": {
        "title": "Sobre las Reservas",
        "howReserve": {
          "q": "¿Cómo hago para reservar un hotel en Fora da Rota?",
          "a": "¡Es súper fácil! Basta entrar en el sitio, elegir tu destino, fechas y comparar las opciones. Cuando encuentres la ideal, solo sigue los pasos para finalizar la compra. La reserva es confirmada y enviada a tu email, después solo tienes que preparar las maletas y hacer el check in usando un documento personal con foto."
        },
        "whyCheaper": {
          "q": "¿Por qué los hoteles en Fora da Rota son más baratos que otros sitios? ¿Y más baratos hasta que el propio hotel?",
          "a": "Nuestros precios son más baratos que otros sitios de viaje y más baratos que el propio hotel porque hacemos acuerdos con súper descuentos con cada socio nuestro. Nuestro equipo está siempre buscando los mejores precios y negociando las mejores condiciones para que puedas reservar las mejores ofertas."
        },
        "hotelGood": {
          "q": "¿Cómo sé si el hotel es bueno?",
          "a": "Hacemos una curaduría exclusiva de los hoteles que destacamos en cada destino. Nuestro equipo investiga, prueba y solo recomienda alojamientos que entregan los mejores servicios, confort y precio para cada tipo de viajero. ¡Puedes confiar en nuestras recomendaciones!"
        },
        "doubts": {
          "q": "Tengo dudas sobre mi reserva, ¿quién puede ayudarme?",
          "a": "Intentamos dejar todas las informaciones sobre tu reserva disponibles en el sitio y en el voucher enviado en la confirmación de tu compra, verifica si ellos consiguen resolver tus dudas. Si tienes alguna duda específica, contáctanos en contato@foradarota.com."
        },
        "instantConfirm": {
          "q": "Si hago una reserva ahora y llamo al hotel, ¿la reserva ya va a estar allí?",
          "a": "¡Sí! La reserva se hace de forma automática en el hotel, así que cuando recibas la confirmación de reserva el hotel ya tendrá tu reserva confirmada y pagada en su sistema. Si el hotel no encuentra la reserva que acabas de hacer, informa que fue hecha hace poco para que actualicen su sistema y encuentren tu reserva."
        },
        "childDiscount": {
          "q": "¿Hay descuento para niños o bebés?",
          "a": "¡Sí! En la búsqueda de tu hotel, informa correctamente el número de adultos y niños, y sus edades, que el sitio ya te traerá las mejores condiciones para ti!"
        },
        "groupDiscount": {
          "q": "¿Hay algún descuento para grupos o familias grandes?",
          "a": "¡Sí! En la búsqueda de tu hotel, informa correctamente el número de adultos y niños que el sitio ya te traerá las mejores condiciones para ti! El número máximo de participantes en una misma reserva es de 8 personas, si necesitas reservar para un grupo mayor será necesario buscar separadamente."
        },
        "minor": {
          "q": "Soy menor de edad, ¿puedo comprar un hotel en Fora Da Rota?",
          "a": "Desafortunadamente no. Nuestros socios no permiten la reserva de menores no acompañados para los alojamientos, será necesario hacer el viaje con algún adulto que tenga autorización legal sobre los menores."
        }
      },
      "payments": {
        "title": "Sobre los Pagos",
        "methods": {
          "q": "¿Cuáles son las formas de pago aceptadas por Fora da Rota?",
          "a": "Para pagos en Euros (EUR) aceptamos pagos vía Google Pay y tarjeta de crédito y débito de todas las banderas. Para pagos en Dólares Americanos (USD) aceptamos pagos vía Google Pay y tarjeta de crédito y débito de todas las banderas. Estamos trabajando para ofrecer el pago vía Klarna en el futuro."
        },
        "installments": {
          "q": "¿Puedo pagar a plazos mi compra?",
          "a": "¡Vamos a permitir el pago a plazos de tu compra en Euros (EUR) y Dólares Americanos (USD) en un futuro próximo!"
        },
        "fees": {
          "q": "¿Cobran tasa de reserva?",
          "a": "¡No cobramos tasa de servicio! El precio que ves ya incluye todas las tasas (a menos que avisemos antes, para tasas que deberán ser pagadas en el lugar)."
        },
        "cardDeclined": {
          "q": "Mi tarjeta de crédito no fue aprobada, ¿qué pasó?",
          "a": "Las compras con tarjeta de crédito pueden ser rechazadas por diversos motivos: transacción no autorizada por el banco emisor (límite, compra sospechosa, tarjeta bloqueada), transacción no confirmada por el cliente (nuestro sitio solicita confirmación en dos pasos), transacción rechazada por sospecha de fraude, o transacción con datos incorrectos. Revisa los datos e intenta de nuevo, o contacta con tu banco."
        },
        "confirmed": {
          "q": "¿Cómo sé si mi reserva fue confirmada?",
          "a": "Así que el pago sea aprobado, recibirás un e-mail con la confirmación de tu pago y enseguida un email de confirmación de tu reserva. La confirmación de la reserva lleva algunos minutitos normalmente, pero puede suceder que lleve hasta 24h. Si hay algún problema con la confirmación de tu reserva, te contactaremos, ¡así que quédate tranquilo!"
        },
        "invoice": {
          "q": "¿Emiten factura?",
          "a": "Sí, al final de tu viaje tendrás acceso a las facturas de tu compra. Según la Ley nº 11.771, de septiembre de 2008, llamada Política Nacional de Turismo, Fora da Rota emitirá la factura solo sobre el valor de remuneración de la agencia. Y corresponde a los socios (empresa de transporte, hospedaje, etc.) la responsabilidad de emitir sus facturas a nombre del consumidor. La suma de las facturas dará el valor total de tu compra."
        }
      },
      "cancellations": {
        "title": "Sobre Alteraciones y Cancelaciones",
        "policy": {
          "q": "¿Cuál es la política de cancelación de mi reserva?",
          "a": "Las políticas de cancelación son de acuerdo con la tarifa elegida. Existen tarifas no reembolsables, tarifas que permiten cancelación con multa y tarifas que permiten cancelación gratuita hasta cierta fecha. Estas reglas de cancelación aparecen de forma detallada en el sitio junto al valor de tu servicio y en el checkout."
        },
        "howCancel": {
          "q": "Quiero cancelar o alterar mi reserva, ¿cómo hago?",
          "a": "Las cancelaciones y alteraciones se hacen a través de nuestro equipo de atención. ¡Contáctanos en contato@foradarota.com con tu solicitud que te vamos a ayudar! Si tu viaje está muy próximo, con 48h o menos para el check in, contacta con el número de teléfono que aparece en tu voucher para tener la asistencia inmediata de nuestros socios."
        },
        "extraFee": {
          "q": "¿Hay tasa extra para reprogramar o cancelar?",
          "a": "Fora da Rota no cobra tasas, pero tenemos que obedecer las reglas de cancelación de tu reserva. Si existen multas o diferencias de valores en la cancelación o reprogramación, te informaremos para que decidas la mejor opción para ti."
        }
      },
      "support": {
        "title": "Ayuda y Soporte para Mi Viaje",
        "noEmail": {
          "q": "¿Qué hacer si mi reserva no aparece en mi e-mail?",
          "a": "¡No te preocupes! Primero, echa un vistazo a tu carpeta de spam. Si no encuentras el e-mail allí, contáctanos y verificaremos tu reserva para ti."
        },
        "duringTrip": {
          "q": "¿Qué hago si necesito ayuda durante mi viaje?",
          "a": "Si necesitas ayuda durante tu viaje contacta con el número de teléfono que aparece en tu voucher para tener la asistencia inmediata de nuestros socios."
        },
        "documents": {
          "q": "¿Qué documentos necesito llevar en mi viaje?",
          "a": "Para viajes internacionales o extranjeros viajando en Brasil será necesario llevar un pasaporte válido (o RG con foto reciente para países del Mercosur) para cada viajero. Además de los documentos de identificación, estate atento a la necesidad de visa, autorizaciones, vacunas y certificados de cada destino."
        }
      },
      "about": {
        "title": "Sobre Fora da Rota",
        "whoWeAre": {
          "q": "¿Quiénes somos?",
          "a": "¡Somos apasionados por viajes y queremos promover destinos aún poco conocidos! Mira más sobre nosotros en nuestra página 'Sobre Nosotros'."
        },
        "safe": {
          "q": "¿Es seguro comprar en Fora da Rota?",
          "a": "¡Sí! Fora da Rota está compuesto por viajeros muy experimentados y con muchos años dedicados al mercado de turismo en Brasil. Mira el testimonio de nuestros viajeros en las redes sociales, Google Reviews, TrustPilot y ReclameAqui."
        },
        "physicalStore": {
          "q": "¿Tienen tienda física?",
          "a": "No tenemos, somos una agencia de viajes totalmente online. ¡En nuestro sitio puedes encontrar todo lo que necesitas!"
        }
      }
    }
  },
  "aboutUs": {
    "pageTitle": "Quiénes Somos - Fora da Rota | Tu Aventura Comienza Aquí",
    "pageDescription": "Conoce al equipo de Fora da Rota: viajeros apasionados que te llevan a destinos auténticos en Brasil.",
    "heroTitle": "¡Tu Aventura Comienza Aquí!",
    "heroSubtitle": "¡Hola, viajero! Si llegaste hasta aquí, es porque, al igual que nosotros, tienes esas ganas de explorar el mundo.",
    "heroIntro": "Somos Fora da Rota, un equipo de apasionados por los viajes que decidió crear un espacio para quienes buscan aventuras de verdad.",
    "features": {
      "prices": {
        "title": "Mejores Precios",
        "description": "Siempre estamos haciendo acuerdos para ofrecerte las mejores condiciones."
      },
      "online": {
        "title": "Todo Online",
        "description": "Compra tu viaje online con rapidez y sin esperar cotizaciones."
      },
      "support": {
        "title": "Soporte",
        "description": "Nuestros socios están listos para ayudarte durante tu viaje."
      }
    },
    "travelersTitle": "Viajeros de Alma, Especialistas de Corazón",
    "travelersText1": "No somos solo otra web de viajes. Somos esos amigos que ya se lanzaron a la carretera sin GPS.",
    "travelersText2": "Tenemos experiencia de sobra en turismo. Sabemos que los mejores lugares no siempre están en las guías tradicionales.",
    "travelersConclusion": "Nuestro objetivo es compartir contigo las experiencias que solo quien conoce los destinos puede ofrecer.",
    "purposeTitle": "¿Nuestro Propósito? Llevarte Donde Pocos Van",
    "purposeText1": "Creemos que viajar es mucho más que coleccionar fotos bonitas.",
    "purposeText2": "Creamos Fora da Rota para:",
    "purposes": {
      "map": "Mapear destinos poco explorados.",
      "tips": "Dar consejos reales, probados y aprobados.",
      "security": "Ofrecer servicios con seguridad y confianza."
    },
    "whyBuyTitle": "¿Por Qué Comprar Con Nosotros?",
    "whyBuyText": "Cada destino que recomendamos es una verdadera pasión nuestra.",
    "whyBuy": {
      "experience": {
        "title": "Experiencia",
        "description": "Viajeros experimentados que conocen los destinos."
      },
      "authentic": {
        "title": "Contenido Auténtico",
        "description": "Recomendaciones basadas en experiencias reales."
      },
      "partners": {
        "title": "Socios de Confianza",
        "description": "Los mejores proveedores de servicios de viaje."
      }
    },
    "stats": {
      "hotels": "Hoteles",
      "destinations": "Destinos",
      "customers": "Clientes Felices",
      "rating": "Valoración"
    },
    "ctaTitle": "¿Listo para tu próxima aventura?",
    "ctaText": "Puedes confiar en que nuestro contenido está pensado para proporcionar los mejores viajes.",
    "teamName": "Equipo Fora da Rota",
    "teamSlogan": "Viajeros de carné, contadores de historias y tus compañeros de aventura."
  },
  "legal": {
    "navigation": "Páginas Legales"
  },
  "terms": {
    "pageTitle": "Términos y Condiciones | Fora da Rota",
    "pageDescription": "Términos y condiciones de uso del sitio Fora da Rota.",
    "breadcrumb": "Términos y Condiciones",
    "title": "Términos de Uso del Sitio Fora da Rota",
    "intro1": "Este Término de Uso (\"Término\") establece las condiciones generales de acceso y utilización del sitio www.foradarota.com.br y www.foradarota.com (\"Sitio\"), propiedad de GJ Empreendimentos Ltda, persona jurídica de derecho privado, inscrita en el CNPJ bajo el nº 49.682.053/0001-29 (\"Fora da Rota\"), y rige la utilización de sus servicios, incluyendo, pero no limitándose a, alojamientos, transportes, alquiler de coches, excursiones, entradas y seguros para viajeros.",
    "intro2": "Al acceder o utilizar el Sitio, el usuario (\"Usuario\") acepta las condiciones descritas en este Término. Si el Usuario no está de acuerdo con alguna cláusula, deberá abstenerse de acceder o utilizar los servicios del Sitio. Recomendamos que lea atentamente todas las disposiciones a continuación antes de realizar cualquier reserva o contratación.",
    "section1Title": "1. Definiciones",
    "section1Intro": "Para efectos de este Término, se consideran las siguientes definiciones:",
    "section1_1": "1.1 Sitio: Plataforma digital donde se ofrecen servicios relacionados con viajes, como alojamientos, transportes, alquiler de vehículos, excursiones turísticas, entradas para atracciones y seguros para viajeros.",
    "section1_2": "1.2 Usuario: Persona física o jurídica que accede y utiliza el Sitio para consultar, adquirir o contratar los servicios ofrecidos.",
    "section1_3": "1.3 Servicios: Productos ofrecidos por el Sitio, incluyendo, pero no limitándose a, reservas de hoteles, billetes aéreos/terrestres, alquiler de vehículos, entradas para atracciones turísticas y seguros de viaje.",
    "section2Title": "2. Aceptación de los Términos",
    "section2_1Intro": "2.1 Al acceder al Sitio y utilizar sus servicios, el Usuario declara que:",
    "section2_1a": "Ha leído, comprendido y aceptado íntegramente estos Términos de Uso;",
    "section2_1b": "Posee capacidad legal para contratar los servicios ofrecidos;",
    "section2_1c": "Proporcionará información verdadera y actualizada durante el proceso de reserva.",
    "section2_2": "2.2 Si el Usuario no está de acuerdo con las disposiciones de este Término, deberá cesar inmediatamente el uso del Sitio.",
    "section2_3": "2.3 El Sitio se reserva el derecho de modificar estos Términos en cualquier momento, correspondiendo al Usuario verificar las posibles actualizaciones.",
    "section3Title": "3. Servicios Ofrecidos",
    "section3_1": "3.1 El Sitio actúa como intermediario en la comercialización de servicios de terceros (hoteleros, compañías aéreas, empresas de alquiler de vehículos, operadores turísticos, aseguradoras, etc.). Por lo tanto, no somos responsables de eventuales alteraciones, cancelaciones o problemas directamente relacionados con los prestadores de los servicios contratados.",
    "section3_2": "3.2 Las condiciones específicas de cada Servicio (como políticas de modificación, políticas de cancelación, equipaje, check-in/check-out, etc.) son responsabilidad de los proveedores y serán informadas durante el proceso de compra del Usuario.",
    "section3_3": "3.3 El Usuario debe verificar las reglas específicas de cada producto antes de la contratación.",
    "section4Title": "4. Obligaciones del Usuario",
    "section4_1Intro": "4.1 El Usuario se compromete a:",
    "section4_1a": "Utilizar los servicios ofrecidos en el Sitio de acuerdo con las leyes brasileñas, los derechos de propiedad intelectual y las disposiciones de este Término.",
    "section4_1b": "Proporcionar información veraz, correcta y completa al cumplimentar los datos solicitados al utilizar los servicios.",
    "section4_1c": "Responsabilizarse de todas las actividades realizadas en su cuenta en el Sitio, incluyendo, pero no limitándose a, accesos no autorizados, uso indebido de datos y contrataciones realizadas.",
    "section4_1d": "Mantener en secreto su contraseña y datos de acceso al Sitio, responsabilizándose de cualquier acto realizado con su cuenta.",
    "section4_1e": "Observar las políticas específicas de cada producto o servicio contratado, incluyendo políticas de cancelación, reembolsos y modificaciones, así como elementos incluidos o no incluidos en los Servicios adquiridos.",
    "section4_1f": "Utilizar el sitio únicamente para fines lícitos, sin fraudes ni mala fe;",
    "section4_1g": "No reproducir, distribuir ni comercializar contenido del sitio sin autorización;",
    "section5Title": "5. Obligaciones de Fora da Rota",
    "section5_1Intro": "5.1 Fora da Rota se compromete a:",
    "section5_1a": "Ofrecer servicios de acuerdo con las descripciones presentadas en el Sitio, en el momento de la compra, garantizando que los productos adquiridos sean entregados o prestados según lo contratado, salvo en casos de fuerza mayor o caso fortuito.",
    "section5_1b": "Proteger los datos personales del Usuario, conforme a la legislación vigente de protección de datos personales, incluyendo la Ley nº 13.709/2018 (Ley General de Protección de Datos Personales - LGPD).",
    "section5_1c": "Poner a disposición del Usuario un canal de atención del Sitio para aclarar dudas sobre el Sitio, proceso de compra o Servicios ofrecidos.",
    "section5_1d": "Facilitar el contacto de soporte y emergencia para cada Servicio contratado por el Usuario. Las instrucciones de contacto estarán descritas en el email de confirmación enviado al Usuario.",
    "section6Title": "6. Contratación de Servicios",
    "section6_1": "6.1 Para la contratación de cualquier servicio en el Sitio, el Usuario deberá seguir las instrucciones de navegación y completar la compra o contratación en el propio Sitio, incluyendo el suministro de datos de pago, cuando sea necesario.",
    "section6_2": "6.2 La contratación de servicios se considerará efectuada tras la confirmación del pago y el envío de un email de confirmación al Usuario.",
    "section6_3": "6.3 El Sitio se reserva el derecho de modificar los precios de los servicios, pudiendo hacerlo sin previo aviso, respetando, sin embargo, el valor acordado para compras ya realizadas.",
    "section6_4": "6.4 Los valores mostrados en el sitio están sujetos a cambios hasta la conclusión de la reserva.",
    "section6_5": "6.5 El Sitio no garantiza la disponibilidad de precios promocionales después del abandono del carrito de compras.",
    "section6_6": "6.6 Formas de pago aceptadas: tarjetas de crédito y Pix.",
    "section6_7": "6.7 Se realizarán análisis de comportamiento y validación con los bancos emisores y servicios externos de antifraude para evaluar la aprobación de las compras realizadas por el Usuario. Fora da Rota se reserva el derecho de denegar compras que considere sospechosas de fraude.",
    "section6_8": "6.8 Fora da Rota se reserva el derecho de crear y divulgar promociones y programas de recompensas que podrán ser utilizados por los Usuarios para adquirir Servicios con precios diferenciados. Cada promoción o programa de recompensa tendrá su reglamento específico divulgado por separado.",
    "section7Title": "7. Cancelación, Reembolso y Modificaciones",
    "section7_1": "7.1 El Usuario podrá solicitar la cancelación de servicios adquiridos, conforme a la política de cancelación y reembolso de cada prestador de servicio o conforme a las condiciones establecidas en el propio sitio, teniendo en cuenta los plazos y condiciones previamente informadas.",
    "section7_2": "7.2 Fora da Rota podrá, a su exclusivo criterio, realizar ajustes en la información sobre disponibilidad y precios de los servicios ofertados, sin perjuicio de los derechos del Usuario en los contratos ya firmados.",
    "section7_3": "7.3 Fora da Rota se reserva el derecho de cancelar o modificar reservas en caso de fraude, error u otras circunstancias excepcionales.",
    "section7_4": "7.4 La no presentación (\"No-Show\") a un Servicio contratado conllevará una penalización del 100%, sin derecho a ningún reembolso ni reprogramación.",
    "section8Title": "8. Responsabilidad",
    "section8_1": "8.1 Fora da Rota no se responsabiliza de ningún fallo en la prestación de los servicios de terceros, como proveedores de alojamiento, transportistas, empresas de alquiler de vehículos, prestadores de servicios turísticos o seguros, excepto en caso de negligencia directa comprobada por su parte.",
    "section8_2": "8.2 El Usuario reconoce y acepta que el uso del Sitio se realiza bajo su exclusiva responsabilidad, y Fora da Rota no se responsabiliza de daños, perjuicios o pérdidas causados por fallos técnicos, virus o cualquier otro motivo que interfiera en el funcionamiento del Sitio.",
    "section8_3": "8.3 El Usuario es responsable de verificar toda la documentación necesaria para el viaje (visados, vacunas, pasaportes, etc.).",
    "section8_4": "8.4 Fora da Rota no se responsabiliza de objetos perdidos, hurtos, robos o cualquier siniestro ocurrido durante, o debido a, el viaje.",
    "section8_5": "8.5 Fora da Rota no se responsabiliza de casos fortuitos o de fuerza mayor (como desastres naturales, huelgas, pandemias).",
    "section9Title": "9. Propiedad Intelectual",
    "section9_1": "9.1 Todos los derechos de propiedad intelectual, incluyendo, pero no limitándose a, contenido, imágenes, textos, marcas y logotipos contenidos en el Sitio son propiedad exclusiva de Fora da Rota o de sus socios comerciales.",
    "section9_2": "9.2 El Usuario no podrá reproducir, copiar, distribuir ni crear obras derivadas de ningún contenido del Sitio sin la previa autorización por escrito de Fora da Rota.",
    "section10Title": "10. Contenido sobre Destinos Turísticos",
    "section10_1": "10.1 El Sitio también ofrece contenido relacionado con destinos turísticos, incluyendo, pero no limitándose a, consejos sobre lugares para visitar, recomendaciones de actividades e información general sobre diferentes localidades.",
    "section10_2": "10.2 El Usuario reconoce que el contenido disponible en el Sitio, especialmente en las secciones de recomendaciones y consejos sobre destinos turísticos, puede haber sido creado con la ayuda de tecnologías de inteligencia artificial (IA) y/o por fuentes externas.",
    "section10_3": "10.3 Fora da Rota se esfuerza por mantener la información actualizada; sin embargo, el contenido disponible en el Sitio puede quedar desactualizado con el tiempo, debido a cambios en las condiciones locales, nueva información o evolución de los destinos turísticos. El Usuario debe siempre verificar la actualidad de la información antes de tomar decisiones basadas en ella, y Fora da Rota no se responsabiliza de ningún perjuicio causado por la desactualización o imprecisión del contenido.",
    "section10_4": "10.4 El contenido proporcionado en el Sitio tiene carácter informativo y orientativo, no siendo responsabilidad de Fora da Rota garantizar la precisión o la totalidad de la información, ni su aplicabilidad o adecuación a las necesidades específicas de cada Usuario.",
    "section10_5": "10.5 Fora da Rota se reserva el derecho de modificar o eliminar cualquier contenido del sitio en cualquier momento, sin previo aviso.",
    "section11Title": "11. Privacidad y Protección de Datos Personales",
    "section11_1": "11.1 Fora da Rota se compromete a tratar los datos personales del Usuario de conformidad con la Ley General de Protección de Datos Personales (Ley nº 13.709/2018), adoptando medidas de seguridad para la protección de los datos personales proporcionados por el Usuario.",
    "section11_2": "11.2 La política de privacidad está disponible en el Sitio de forma separada y estos Términos de Uso obedecen las definiciones de privacidad allí descritas.",
    "section11_3": "11.3 Al aceptar los Términos de Uso del Sitio, también está aceptando la política de privacidad.",
    "section12Title": "12. Modificación de los Términos",
    "section12_1": "12.1 Fora da Rota podrá modificar este Término de Uso en cualquier momento, mediante la publicación de una versión actualizada en el Sitio. La fecha de la última actualización se indicará al inicio de este documento.",
    "section12_2": "12.2 El Usuario acepta que el uso continuado del Sitio después de cualquier modificación implicará la aceptación de los nuevos términos.",
    "section13Title": "13. Ley Aplicable y Fuero",
    "section13_1": "13.1 Este Término de Uso será regido e interpretado de acuerdo con las leyes de la República Federativa de Brasil.",
    "section13_2": "13.2 Se elige el fuero de la comarca de Florianópolis, Estado de Santa Catarina, para dirimir cualquier controversia derivada del presente Término, con renuncia a cualquier otro, por más privilegiado que sea.",
    "section14Title": "14. Disposiciones Generales",
    "section14_1": "14.1 Este Término no genera ningún contrato de sociedad, mandato, franquicia o relación laboral entre Fora da Rota y el Usuario.",
    "section14_2": "14.2 Si alguna cláusula de este Término fuese considerada nula o inaplicable, las demás cláusulas permanecerán en vigor.",
    "section14_3": "14.3 El incumplimiento, por cualquiera de las partes, de cualquier cláusula de este instrumento no implicará la renuncia a ese derecho o la aceptación del incumplimiento, pudiendo ser ejercido en cualquier momento.",
    "lastUpdate": "Última actualización: 31 de marzo de 2025."
  },
  "privacy": {
    "pageTitle": "Política de Privacidad | Fora da Rota",
    "pageDescription": "Política de privacidad de Fora da Rota.",
    "breadcrumb": "Política de Privacidad",
    "title": "Política de Privacidad – Fora da Rota",
    "intro1": "GJ Empreendimentos Ltda (en adelante \"Fora da Rota\"), inscrita en el CNPJ bajo el nº 49.682.053/0001-29, se compromete a proteger la privacidad y los datos personales de los usuarios de su sitio web (www.foradarota.com.br o www.foradarota.com), sus servicios y productos.",
    "intro2": "La presente Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos la información de los usuarios al acceder o utilizar los servicios ofrecidos a través de nuestro sitio web, incluyendo, pero no limitándose a, información relativa a la consulta y compra de alojamientos, transportes, coches de alquiler, excursiones, entradas y seguros para viajeros.",
    "intro3": "Al utilizar nuestros servicios, usted acepta las prácticas descritas en esta política. Si no está de acuerdo, le solicitamos que no continúe navegando ni proporcionando sus datos.",
    "section1Title": "1. Recopilación de Información Personal",
    "section1Intro": "Al acceder o utilizar nuestro sitio web y servicios, podemos recopilar la siguiente información personal:",
    "section1_1Title": "1.1 Datos recopilados automáticamente:",
    "section1_1_1": "Datos de navegación: información sobre su dispositivo, navegador, dirección IP, páginas visitadas y otra información recopilada mediante cookies y tecnologías similares, para mejorar la experiencia de navegación, personalización de ofertas, análisis de comportamiento y verificación de ubicación de compra para la detección de fraudes.",
    "section1_2Title": "1.2 Datos proporcionados por el usuario:",
    "section1_2_1": "Datos de registro: nombre, fecha de nacimiento, correo electrónico, teléfono, documento de identidad, dirección y otra información necesaria para el registro de cuenta o para realizar compras.",
    "section1_2_2": "Datos de transacciones: información sobre las compras realizadas, como datos de pago (tarjetas de crédito, débito u otras formas de pago) e historial de transacciones.",
    "section1Note1": "Todos los datos recopilados, listados anteriormente, son esenciales para la operación y entrega de los servicios ofrecidos. La falta de alguna información puede ocasionar fallos en el funcionamiento del sitio e impedimento para la compra de servicios.",
    "section1Note2": "La recopilación de esta información se realiza de manera transparente y con el consentimiento del usuario, conforme a lo expuesto en esta Política de Privacidad.",
    "section2Title": "2. Uso de la Información Personal",
    "section2Intro": "La información recopilada se utiliza para las siguientes finalidades:",
    "section2_1": "Prestación de servicios: para viabilizar la venta de productos y servicios, como alojamientos, transportes, coches de alquiler, excursiones, entradas y seguros para viajeros.",
    "section2_2": "Procesamiento de pagos: para facilitar el procesamiento de pagos con, pero no limitado a, instituciones de pago como adquirentes de tarjetas de crédito e instituciones participantes del sistema de pago Pix, empresas de análisis de fraudes y verificación de identidades.",
    "section2_3": "Comunicación: para enviar confirmaciones de pedidos, actualizaciones sobre reservas, promociones, ofertas y otras comunicaciones relacionadas con el uso de nuestros servicios, siempre con su consentimiento.",
    "section2_4": "Mejora de servicios: para personalizar su experiencia de navegación y mejorar la calidad de nuestros servicios, ofreciendo sugerencias de destinos y productos que puedan ser de su interés.",
    "section2_5": "Seguridad: para cumplir con obligaciones legales, prevenir fraudes y garantizar la seguridad del sitio y de los datos de los usuarios.",
    "section3Title": "3. Compartición de Datos Personales",
    "section3Intro": "Fora da Rota puede compartir la información personal recopilada con terceros en las siguientes situaciones:",
    "section3_1": "Prestadores de servicios: empresas asociadas que nos ayudan en la operación del sitio y en la ejecución de los servicios contratados, como plataformas de pago, empresas de transporte, alojamiento, seguros, entre otras. Estos prestadores de servicios tendrán acceso a los datos necesarios para realizar la transacción solicitada, pero están obligados a mantener la confidencialidad y seguridad de la información.",
    "section3_2": "Obligación legal: cuando sea necesario para cumplir con obligaciones legales o regulatorias, o para responder a solicitudes de autoridades competentes.",
    "section3_3": "Transferencia de negocio: en caso de venta, fusión o reestructuración de la empresa, la información de los usuarios podrá ser transferida a los nuevos propietarios, siendo informados previamente sobre cualquier cambio en las condiciones de uso de sus datos personales.",
    "section4Title": "4. Almacenamiento y Seguridad de los Datos",
    "section4_1": "Fora da Rota adopta medidas técnicas y administrativas adecuadas para proteger los datos personales de los usuarios contra accesos no autorizados, pérdidas, alteraciones o divulgaciones indebidas. Sin embargo, destacamos que ninguna transmisión de datos por internet es completamente segura, y no podemos garantizar la total seguridad de los datos durante el proceso de transmisión.",
    "section4_2": "Los datos personales recopilados serán almacenados durante el período necesario para la ejecución de los servicios contratados, cumplimiento de obligaciones legales y para el ejercicio de derechos en procesos judiciales, administrativos o arbitrales.",
    "section5Title": "5. Cookies y Tecnologías Similares",
    "section5_1": "Utilizamos cookies y otras tecnologías de rastreo para mejorar la experiencia de navegación en el sitio. Las cookies son pequeños archivos almacenados en su dispositivo que nos ayudan a personalizar el contenido y ofrecer anuncios relevantes, así como a analizar el comportamiento de navegación en el sitio.",
    "section5_2": "El usuario puede configurar su navegador para rechazar cookies, pero al hacerlo, podrá no conseguir acceder a determinadas funcionalidades del sitio.",
    "section6Title": "6. Derechos del Usuario",
    "section6_1": "El usuario tiene derecho a acceder, corregir, eliminar o solicitar la portabilidad de sus datos personales, conforme a lo previsto por la Ley General de Protección de Datos (Ley nº 13.709/2018). Para ejercer estos derechos, el usuario puede contactarnos a través de los canales de atención disponibles en el sitio.",
    "section6_2": "Además, el usuario puede revocar el consentimiento dado en cualquier momento, mediante contacto con nuestro soporte, sin perjuicio de la legalidad de los tratamientos realizados antes de la revocación.",
    "section7Title": "7. Modificaciones en la Política de Privacidad",
    "section7_1": "Fora da Rota se reserva el derecho de modificar esta Política de Privacidad en cualquier momento, con el fin de reflejar cambios en la legislación o en nuestros procesos. Recomendamos que los usuarios revisen periódicamente esta política para estar al tanto de posibles actualizaciones.",
    "section8Title": "8. Contacto",
    "section8Intro": "Para más información sobre nuestra Política de Privacidad o para ejercer sus derechos, contacte con nosotros a través de:",
    "section8Email": "E-mail: contato@foradarota.com",
    "section8Note": "La presente Política de Privacidad se rige por las leyes brasileñas, en especial por la Ley General de Protección de Datos (Ley nº 13.709/2018) y el Código de Defensa del Consumidor (CDC).",
    "footer": "Esta política ha sido elaborada de acuerdo con las directrices legales y en conformidad con los principios de transparencia y respeto a la privacidad de nuestros usuarios. Agradecemos su confianza y seguimos comprometidos en proteger sus datos personales.",
    "lastUpdate": "Última actualización: 31 de marzo de 2025."
  },
  "filters": {
    "title": "Filtros",
    "titleFor": "Filtros de {{type}}",
    "description": "Refina tu búsqueda con los siguientes filtros",
    "pricePerNight": "Precio por Noche",
    "stars": "Estrellas",
    "boardType": "Régimen de Comidas",
    "cancellationPolicy": "Política de Cancelación",
    "all": "Todas",
    "refundable": "Reembolsable",
    "nonRefundable": "No Reembolsable",
    "sortBy": "Ordenar por",
    "default": "Recomendados",
    "priceLowToHigh": "Precio: Menor a Mayor",
    "priceHighToLow": "Precio: Mayor a Menor",
    "nameAZ": "Nombre: A-Z",
    "nameZA": "Nombre: Z-A",
    "apply": "Aplicar Filtros",
    "clear": "Limpiar Filtros",
    "showOnMap": "Ver en mapa",
    "mapPreview": "Vista previa del mapa",
    "searchByName": "Buscar por nombre",
    "searchPlaceholder": "ej: Hotel Marriott",
    "recommendations": "Recomendaciones",
    "recommendedOnly": "Solo hoteles recomendados"
  },
  "map": {
    "hotelsMap": "Mapa de hoteles",
    "of": "de",
    "activeFilter": "filtro activo",
    "activeFilters": "filtros activos",
    "errorLoading": "Error al cargar el mapa",
    "noHotelsWithCoordinates": "No hay hoteles con coordenadas disponibles"
  },
  "home": {
    "stats": {
      "destinations": "Destinos",
      "rating": "Valoración"
    },
    "categories": {
      "title": "Categorías de Viaje",
      "subtitle": "Lo que ofrecemos",
      "hotels": {
        "description": "Desde resorts de lujo hasta acogedoras pousadas"
      },
      "resorts": {
        "description": "Experiencias todo incluido en los destinos más paradisíacos"
      }
    },
    "resortDestinations": {
      "subtitle": "Resorts All Inclusive",
      "title": "Destinos de Resorts"
    },
    "destinations": {
      "rio": {
        "location": "Estado de Río",
        "description": "La Ciudad Maravillosa te espera con playas paradisíacas, el Cristo Redentor y un carnaval inolvidable."
      },
      "noronha": {
        "description": "Archipiélago paradisíaco con las aguas más cristalinas de Brasil. Perfecto para buceo y naturaleza."
      },
      "amazonas": {
        "location": "Norte de Brasil",
        "description": "Explora la selva tropical más grande del mundo. Aventura, biodiversidad y culturas ancestrales."
      }
    },
    "features": {
      "title": "¿Por Qué Elegirnos?",
      "subtitle": "Tu tranquilidad es nuestra prioridad",
      "secureBooking": {
        "title": "Reserva Segura",
        "description": "Sistema de pago seguro y garantía de mejor precio"
      },
      "easyPayment": {
        "title": "Pago Fácil",
        "description": "Múltiples opciones de pago en euros"
      },
      "support": {
        "title": "Soporte 24/7",
        "description": "Asistencia en español durante todo tu viaje"
      }
    },
    "faq": {
      "whyBook": {
        "question": "¿Por qué reservar con Fora da Rota?",
        "answer": "Ofrecemos precios competitivos, sistema de pago seguro en euros, y soporte en español 24/7 durante tu viaje por Brasil."
      },
      "destinations": {
        "question": "¿Qué destinos en Brasil puedo reservar?",
        "answer": "Ofrecemos hoteles en los principales destinos de Brasil como Río de Janeiro, Fernando de Noronha, Amazonas, Salvador, Florianópolis y muchos más."
      },
      "payment": {
        "question": "¿Cómo puedo pagar mi reserva?",
        "answer": "Aceptamos múltiples métodos de pago incluyendo tarjetas de crédito, débito, Apple Pay, Google Pay y Klarna. Todas las transacciones son en euros."
      }
    },
    "cta": {
      "title": "¿Listo para Tu Aventura Brasileña?",
      "description": "Miles de viajeros ya han confiado en nosotros. Comienza a planear tu viaje hoy.",
      "button": "Comenzar Ahora"
    },
    "seoContent": {
      "title": "Tu Agencia de Viajes Especializada en Brasil",
      "subtitle": "Conoce Fora da Rota",
      "paragraph1": "Fora da Rota nació de la pasión por descubrir Brasil más allá de los destinos convencionales. Somos una agencia de viajes online especializada en turismo brasileño, ofreciendo a viajeros de todo el mundo la oportunidad de explorar desde las playas paradisíacas del Nordeste hasta la exuberante selva amazónica.",
      "paragraph2": "Nuestra plataforma te permite reservar hoteles, resorts all inclusive y experiencias únicas en los destinos más increíbles de Brasil. Trabajamos directamente con los mejores establecimientos para garantizarte precios competitivos en euros, con sistema de pago seguro y soporte en español durante todo tu viaje.",
      "destinationsTitle": "Destinos Imperdibles en Brasil",
      "destinationsText": "Brasil es un país de dimensiones continentales con una diversidad que sorprende. En Río de Janeiro, admira el Cristo Redentor y relájate en las famosas playas de Copacabana e Ipanema. Fernando de Noronha ofrece aguas cristalinas perfectas para buceo y snorkel. La región Nordeste te espera con Porto de Galinhas, Maragogi y las dunas de los Lençóis Maranhenses. En el Sur, Florianópolis combina playas paradisíacas con gastronomía excepcional.",
      "resortsTitle": "Resorts All Inclusive de Calidad",
      "resortsText": "Para quienes buscan comodidad total, ofrecemos los mejores resorts all inclusive de Brasil y el Caribe. Costa do Sauípe, Iberostar Praia do Forte, Vila Galé Marés y muchos otros establecimientos de primera categoría están disponibles en nuestra plataforma con las mejores tarifas garantizadas.",
      "whyUsTitle": "Por Qué Elegir Fora da Rota",
      "whyUsText": "Reservar con nosotros significa disfrutar de atención personalizada, precios transparentes sin sorpresas, confirmación instantánea y la tranquilidad de contar con soporte 24/7 en español. Ya seas viajero solo, pareja o familia, encontrarás la opción perfecta para tu aventura brasileña."
    },
    "featuredDestinations": {
      "subtitle": "Guías de viaje",
      "title": "Destinos destacados"
    }
  },
  "searchEdit": {
    "title": "Modificar búsqueda",
    "description": "Cambia las fechas o el número de huéspedes para buscar disponibilidad",
    "addChild": "Añadir niño",
    "noChildren": "Sin niños",
    "year": "año",
    "years": "años",
    "modify": "Modificar"
  },
  "noAvailability": {
    "title": "Sin disponibilidad",
    "description": "Este hotel no tiene disponibilidad para las nuevas fechas o número de huéspedes seleccionados.",
    "question": "¿Qué te gustaría hacer?",
    "stayOnPage": "Quedarme aquí",
    "goToResults": "Ver otros hoteles"
  },
  "hotelFaq": {
    "title": "Preguntas Frecuentes",
    "subtitle": "Información útil sobre este hotel basada en los datos disponibles",
    "questionsCount": "{{count}} preguntas frecuentes",
    "categories": {
      "general": "General",
      "checkInOut": "Check-in y Check-out",
      "location": "Ubicación",
      "meals": "Comidas",
      "rooms": "Habitaciones",
      "policies": "Políticas",
      "amenities": "Comodidades",
      "services": "Servicios",
      "contact": "Contacto",
      "dining": "Gastronomía"
    },
    "destination": {
      "question": "¿En qué destino se encuentra {{hotelName}}?",
      "answer": "{{hotelName}} se encuentra en {{destinationName}}."
    },
    "checkIn": {
      "question": "¿A qué hora es el check-in en {{hotelName}}?",
      "answerWithTime": "El check-in en {{hotelName}} es a partir de las {{time}}.",
      "answerDefault": "El check-in en {{hotelName}} generalmente es a partir de las 14:00. Consulta con el hotel para confirmar."
    },
    "checkOut": {
      "question": "¿A qué hora es el check-out en {{hotelName}}?",
      "answerWithTime": "El check-out en {{hotelName}} es hasta las {{time}}.",
      "answerDefault": "El check-out en {{hotelName}} generalmente es hasta las 10:00. Consulta con el hotel para confirmar."
    },
    "location": {
      "question": "¿Dónde está ubicado {{hotelName}}?",
      "answer": "{{hotelName}} está ubicado en {{address}}."
    },
    "meals": {
      "question": "¿Qué opciones de comida están disponibles en {{hotelName}}?",
      "answer": "Las opciones de régimen disponibles en {{hotelName}} son: {{options}}."
    },
    "breakfast": {
      "question": "¿El desayuno está incluido en {{hotelName}}?",
      "answerYes": "Sí, hay opciones con desayuno incluido disponibles en {{hotelName}}.",
      "answerDepends": "Depende de la tarifa elegida en {{hotelName}}. Verifica las opciones de habitación para ver cuáles incluyen desayuno."
    },
    "beds": {
      "question": "¿Qué tipos de cama están disponibles en {{hotelName}}?",
      "answer": "Los tipos de cama disponibles en {{hotelName}} son: {{options}}."
    },
    "roomOptions": {
      "question": "¿Cuántas opciones de habitación hay en {{hotelName}}?",
      "answer": "{{hotelName}} tiene {{count}} opciones de habitación disponibles para las fechas seleccionadas."
    },
    "cancellation": {
      "question": "¿Cuál es la política de cancelación en {{hotelName}}?",
      "answerMixed": "{{hotelName}} ofrece tanto tarifas reembolsables como no reembolsables. Verifica los detalles de cada habitación para conocer las condiciones específicas.",
      "answerNonRefundable": "Las tarifas disponibles actualmente en {{hotelName}} son no reembolsables. Verifica los detalles de cada habitación para más información."
    },
    "pets": {
      "question": "¿{{hotelName}} acepta mascotas?",
      "answerYes": "Sí, {{hotelName}} es pet-friendly y acepta mascotas.",
      "answerNo": "No, {{hotelName}} no acepta mascotas."
    },
    "wifi": {
      "question": "¿{{hotelName}} tiene WiFi?",
      "answerYes": "Sí, {{hotelName}} ofrece WiFi para sus huéspedes."
    },
    "parking": {
      "question": "¿{{hotelName}} tiene estacionamiento?",
      "answerYes": "Sí, {{hotelName}} dispone de estacionamiento."
    },
    "pool": {
      "question": "¿{{hotelName}} tiene piscina?",
      "answerYes": "Sí, {{hotelName}} cuenta con piscina."
    },
    "contact": {
      "question": "¿Cómo puedo contactar a {{hotelName}}?",
      "answer": "Puedes contactar a {{hotelName}} por teléfono: {{phone}}."
    }
  },
  "resorts": {
    "badge": "Experiencias All Inclusive",
    "heroTitle": "Descubre tu Resort Ideal",
    "heroSubtitle": "Los mejores resorts all inclusive en destinos paradisíacos. Relájate y disfruta sin preocupaciones.",
    "breadcrumb": "Resorts",
    "pageTitle": "Resorts All Inclusive - Reserva Online con Mejores Precios | Fora da Rota",
    "pageDescription": "Reserva resorts all inclusive en Brasil, Caribe, África y Europa. Encuentra las mejores ofertas con todo incluido: comidas, bebidas y actividades. Reserva online fácil y segura.",
    "pageTitleWithDestination": "Resorts All Inclusive en {{destination}} - Mejores Precios | Fora da Rota",
    "pageDescriptionWithDestination": "Descubre los mejores resorts all inclusive en {{destination}}. Ofertas exclusivas con todo incluido: comidas, bebidas y actividades. Reserva online con los mejores precios.",
    "selectDestination": "Destino",
    "chooseDestination": "Elige un destino",
    "featuredDestinations": "Destinos Destacados",
    "selectDatesAbove": "Selecciona fechas arriba para buscar",
    "searching": "Buscando resorts...",
    "searchingSubtitle": "Esto puede tardar un poco más, estamos consultando varios resorts a la vez",
    "retrying": "Reintentando búsqueda...",
    "retryingDescription": "Intento {{attempt}} de {{max}} - El proveedor no respondió, intentando nuevamente",
    "noResultsTitle": "Sin resultados",
    "noResultsAfterRetries": "No encontramos resorts disponibles después de varios intentos",
    "searchTips": {
      "tip1": "Los resorts all inclusive suelen incluir todas las comidas, bebidas y actividades",
      "tip2": "Reservar con anticipación puede garantizar mejores precios y disponibilidad",
      "tip3": "Verifica qué actividades están incluidas antes de reservar",
      "tip4": "Algunos resorts ofrecen servicios de spa y golf con costo adicional",
      "tip5": "Los resorts frente al mar suelen tener las mejores vistas y acceso directo a la playa"
    },
    "searchComplete": "Búsqueda completada",
    "resortsFound": "{{count}} resorts encontrados",
    "propertiesFound": "resorts encontrados",
    "noResults": "No encontramos resorts disponibles para estas fechas",
    "noResultsDescription": "Intenta con otras fechas o destino",
    "allResorts": "Todos los Resorts",
    "destinations": {
      "brasil": "Resorts All Inclusive en Brasil",
      "caribe": "Resorts All Inclusive en el Caribe",
      "africa": "Resorts All Inclusive en África",
      "europa": "Resorts All Inclusive en Europa",
      "outros": "Resorts All Inclusive en Otros Lugares"
    },
    "regions": {
      "brasil": {
        "metaTitle": "Resorts All Inclusive en Brasil - Mejores Precios 2025 | Fora da Rota",
        "metaDescription": "Descubre los mejores resorts all inclusive de Brasil. Desde Bahia hasta Rio Grande do Norte, reserva con los mejores precios. Todo incluido: comidas, bebidas y actividades.",
        "heroTitle": "Resorts All Inclusive en Brasil",
        "heroSubtitle": "Descubre el paraíso brasileño con experiencias all inclusive inolvidables",
        "seoTitle": "Guía Completa de Resorts All Inclusive en Brasil",
        "seoContent": "<h2>Los Mejores Destinos para Resorts All Inclusive en Brasil</h2><p>Brasil ofrece algunos de los resorts all inclusive más espectaculares del mundo, combinando playas paradisíacas, cultura vibrante y hospitalidad única. Desde las costas tropicales de <strong>Bahia</strong> hasta las dunas impresionantes de <strong>Rio Grande do Norte</strong>, cada región ofrece experiencias únicas para viajeros exigentes.</p><h3>Principales Regiones de Resorts en Brasil</h3><p>El <strong>Nordeste brasileño</strong> concentra la mayoría de los resorts all inclusive premium, con destinos como <strong>Porto de Galinhas</strong>, <strong>Morro de São Paulo</strong>, <strong>Praia do Forte</strong> y <strong>Costa do Sauípe</strong>. El litoral sur también ofrece opciones sofisticadas en <strong>Santa Catarina</strong> y <strong>Rio de Janeiro</strong>.</p><h3>Mejor Época para Viajar</h3><p>La temporada ideal para visitar resorts en Brasil es de <strong>septiembre a marzo</strong>, cuando el clima es cálido y seco en la mayor parte del país. El verano brasileño (diciembre a febrero) es perfecto para familias en vacaciones, mientras que septiembre a noviembre ofrece precios más accesibles.</p><h3>Experiencias para Todos los Gustos</h3><p>Los resorts brasileños son perfectos para <strong>viajes en familia</strong>, con clubes infantiles y actividades para todas las edades. Las <strong>parejas románticas</strong> encontrarán spas de clase mundial y cenas a la luz de las velas. Los amantes de la <strong>aventura</strong> pueden disfrutar de deportes acuáticos, buceo y excursiones ecológicas.</p>"
      },
      "caribe": {
        "metaTitle": "Resorts All Inclusive en el Caribe - Mejores Ofertas 2025 | Fora da Rota",
        "metaDescription": "Reserva resorts all inclusive en el Caribe: México, República Dominicana, Jamaica, Aruba y más. Playas de arena blanca y aguas cristalinas con todo incluido.",
        "heroTitle": "Resorts All Inclusive en el Caribe",
        "heroSubtitle": "Playas de ensueño y lujo all inclusive en el paraíso caribeño",
        "seoTitle": "Guía Completa de Resorts All Inclusive en el Caribe",
        "seoContent": "<h2>Los Mejores Destinos All Inclusive del Caribe</h2><p>El Caribe es sinónimo de vacaciones perfectas, con aguas turquesas, playas de arena blanca y los mejores resorts all inclusive del mundo. Desde <strong>Cancún</strong> y la <strong>Riviera Maya</strong> en México hasta las islas de <strong>Jamaica</strong>, <strong>República Dominicana</strong> y <strong>Aruba</strong>, cada destino ofrece experiencias únicas.</p><h3>Principales Destinos Caribeños</h3><p><strong>México</strong> lidera con la Riviera Maya, Cancún y Los Cabos. <strong>República Dominicana</strong> destaca con Punta Cana y Puerto Plata. <strong>Jamaica</strong> ofrece Montego Bay y Negril. Las <strong>Antillas Holandesas</strong> brillan con Aruba y Curaçao, mientras que <strong>Cuba</strong> seduce con Varadero.</p><h3>Mejor Época para Viajar</h3><p>La temporada alta va de <strong>diciembre a abril</strong>, con clima seco y temperaturas perfectas. De <strong>mayo a noviembre</strong> encontrarás precios más bajos, aunque es temporada de lluvias. Evita agosto y septiembre por riesgo de huracanes en algunas zonas.</p><h3>Experiencias Únicas</h3><p>Ideal para <strong>lunas de miel y parejas</strong> buscando romance, con resorts solo para adultos y spas de lujo. Las <strong>familias</strong> disfrutarán de parques acuáticos y programas infantiles. Los <strong>aventureros</strong> encontrarán snorkel en arrecifes, cenotes mágicos y excursiones a ruinas mayas.</p>"
      },
      "africa": {
        "metaTitle": "Resorts All Inclusive en África - Safari y Playa 2025 | Fora da Rota",
        "metaDescription": "Descubre resorts all inclusive en África: Egipto, Mauricio, Seychelles, Sudáfrica. Combina safari con playas paradisíacas. Experiencias únicas todo incluido.",
        "heroTitle": "Resorts All Inclusive en África",
        "heroSubtitle": "Safari, playas exóticas y experiencias all inclusive inolvidables",
        "seoTitle": "Guía Completa de Resorts All Inclusive en África",
        "seoContent": "<h2>Descubre los Resorts All Inclusive de África</h2><p>África ofrece una combinación única de safari, playas paradisíacas y resorts de lujo all inclusive. Desde las costas de <strong>Egipto</strong> en el Mar Rojo hasta las islas tropicales de <strong>Mauricio</strong> y <strong>Seychelles</strong>, el continente promete experiencias inolvidables.</p><h3>Destinos Destacados</h3><p><strong>Egipto</strong> lidera con Hurghada y Sharm el-Sheikh, perfectos para buceo y sol. <strong>Mauricio</strong> ofrece resorts de ultra lujo con spas ayurvédicos. Las <strong>Seychelles</strong> son sinónimo de exclusividad. <strong>Sudáfrica</strong> combina safari con playas de Cape Town, mientras que <strong>Kenia</strong> y <strong>Tanzania</strong> ofrecen lodges safari all inclusive.</p><h3>Mejor Época para Viajar</h3><p>Depende del destino: <strong>Egipto</strong> es ideal todo el año, especialmente de marzo a mayo y septiembre a noviembre. <strong>Mauricio y Seychelles</strong> brillan de mayo a diciembre. Para <strong>safaris en África Oriental</strong>, julio a octubre es la temporada de migración.</p><h3>Experiencias Incomparables</h3><p>Perfectos para <strong>viajes románticos</strong> y lunas de miel en islas privadas. Las <strong>familias aventureras</strong> pueden combinar safari con playa. Los <strong>amantes del buceo</strong> encontrarán arrecifes espectaculares en el Mar Rojo.</p>"
      },
      "europa": {
        "metaTitle": "Resorts All Inclusive en Europa - Mediterráneo 2025 | Fora da Rota",
        "metaDescription": "Reserva resorts all inclusive en Europa: España, Grecia, Turquía, Portugal. Costa mediterránea con todo incluido. Cultura, gastronomía y playas perfectas.",
        "heroTitle": "Resorts All Inclusive en Europa",
        "heroSubtitle": "Mediterráneo, cultura y gastronomía en resorts all inclusive premium",
        "seoTitle": "Guía Completa de Resorts All Inclusive en Europa",
        "seoContent": "<h2>Los Mejores Resorts All Inclusive de Europa</h2><p>Europa ofrece resorts all inclusive que combinan playas mediterráneas con rica cultura, gastronomía excepcional e historia milenaria. Desde las <strong>Islas Canarias</strong> y <strong>Baleares</strong> en España hasta las costas de <strong>Grecia</strong> y <strong>Turquía</strong>, cada destino es único.</p><h3>Destinos Europeos Premium</h3><p><strong>España</strong> destaca con las Islas Canarias (Tenerife, Gran Canaria, Lanzarote), Mallorca e Ibiza. <strong>Grecia</strong> brilla con Creta, Rodas y Santorini. <strong>Turquía</strong> ofrece la Riviera Turca (Antalya, Bodrum). <strong>Portugal</strong> seduce con el Algarve, y <strong>Croacia</strong> emerge con su costa dálmata.</p><h3>Mejor Época para Viajar</h3><p>La temporada ideal es de <strong>mayo a octubre</strong>, con el pico en julio y agosto. <strong>Junio y septiembre</strong> ofrecen clima perfecto con menos multitudes y mejores precios. Las Islas Canarias son excepcionales todo el año con clima subtropical.</p><h3>Experiencias Variadas</h3><p>Ideales para <strong>familias</strong> con actividades culturales y parques temáticos cercanos. Perfectos para <strong>parejas</strong> que buscan romance combinado con excursiones históricas. Los <strong>amantes de la gastronomía</strong> disfrutarán de cocina mediterránea incluida en los paquetes.</p>"
      },
      "outros": {
        "metaTitle": "Resorts All Inclusive Exóticos - Asia, Oceanía, Oriente 2025 | Fora da Rota",
        "metaDescription": "Descubre resorts all inclusive en destinos exóticos: Maldivas, Tailandia, Bali, Dubái. Experiencias únicas en paraísos remotos con todo incluido.",
        "heroTitle": "Resorts All Inclusive en Destinos Exóticos",
        "heroSubtitle": "Maldivas, Asia y más: destinos únicos con experiencias all inclusive exclusivas",
        "seoTitle": "Guía Completa de Resorts All Inclusive Exóticos",
        "seoContent": "<h2>Resorts All Inclusive en Destinos Exóticos</h2><p>Más allá del Caribe y Europa, el mundo ofrece destinos extraordinarios con resorts all inclusive de clase mundial. Desde las <strong>Maldivas</strong> hasta <strong>Tailandia</strong>, pasando por <strong>Bali</strong> y <strong>Dubái</strong>, cada destino promete experiencias inolvidables.</p><h3>Destinos Destacados</h3><p>Las <strong>Maldivas</strong> son el epítome del lujo con villas sobre el agua. <strong>Tailandia</strong> ofrece Phuket y Koh Samui con cultura y playas. <strong>Bali</strong> combina espiritualidad con resorts de diseño. <strong>Dubái</strong> sorprende con mega-resorts futuristas. <strong>Fiji</strong> y las <strong>Islas del Pacífico</strong> ofrecen paraísos remotos.</p><h3>Mejor Época para Viajar</h3><p><strong>Maldivas</strong>: noviembre a abril (estación seca). <strong>Tailandia</strong>: noviembre a febrero. <strong>Bali</strong>: abril a octubre. <strong>Dubái</strong>: octubre a abril (clima agradable). Cada destino tiene su temporada ideal, evitando monzones o calor extremo.</p><h3>Experiencias Extraordinarias</h3><p>Perfectos para <strong>lunas de miel</strong> en islas privadas de Maldivas. Las <strong>familias</strong> amarán los mega-resorts de Dubái con parques acuáticos. Los <strong>aventureros espirituales</strong> encontrarán retiros de yoga y bienestar en Bali y Tailandia.</p>"
      }
    },
    "faq": {
      "title": "Preguntas Frecuentes",
      "brasil": {
        "q1": "¿Cuáles son los mejores resorts all inclusive en Brasil?",
        "a1": "Los mejores resorts all inclusive en Brasil incluyen Costa do Sauípe, Iberostar Bahia, Grand Palladium Imbassaí, Sauípe Premium y Vila Galé Marés. Estos resorts ofrecen playas paradisíacas, gastronomía de calidad y actividades para toda la familia.",
        "q2": "¿Cuál es la mejor época para visitar resorts en Brasil?",
        "a2": "La mejor época es de septiembre a marzo, cuando el clima es cálido y seco. El verano brasileño (diciembre a febrero) es ideal para familias, mientras que septiembre a noviembre ofrece precios más accesibles y menos multitudes.",
        "q3": "¿Qué está incluido en los resorts all inclusive de Brasil?",
        "a3": "Los resorts all inclusive en Brasil generalmente incluyen alojamiento, todas las comidas y bebidas (incluyendo alcohólicas), actividades recreativas, entretenimiento nocturno, piscinas, acceso a la playa, y en muchos casos, deportes acuáticos y club infantil.",
        "q4": "¿Los resorts brasileños son buenos para familias con niños?",
        "a4": "Sí, los resorts brasileños son excelentes para familias. La mayoría cuenta con clubes infantiles, áreas de recreación, piscinas para niños, animación infantil y menús especiales. Destinos como Porto de Galinhas y Praia do Forte son especialmente recomendados para familias.",
        "q5": "¿Cómo llegar a los principales resorts de Brasil?",
        "a5": "Los principales resorts del Nordeste están cerca de aeropuertos internacionales como Salvador (para Costa do Sauípe y Praia do Forte), Recife (para Porto de Galinhas) y Natal (para Pipa). Muchos resorts ofrecen transfers desde el aeropuerto incluidos en el paquete."
      },
      "caribe": {
        "q1": "¿Cuáles son los mejores destinos all inclusive en el Caribe?",
        "a1": "Los destinos más populares incluyen Punta Cana (República Dominicana), Cancún y Riviera Maya (México), Montego Bay (Jamaica), Aruba y Varadero (Cuba). Cada uno ofrece playas espectaculares y resorts de clase mundial.",
        "q2": "¿Es seguro viajar a resorts del Caribe?",
        "a2": "Sí, los resorts all inclusive del Caribe son muy seguros. Las instalaciones tienen seguridad 24/7 y las zonas turísticas están bien protegidas. Siempre recomendamos seguir las precauciones básicas de viaje y contratar un seguro de viaje.",
        "q3": "¿Cuándo es la temporada de huracanes en el Caribe?",
        "a3": "La temporada de huracanes va de junio a noviembre, con mayor actividad en agosto y septiembre. Si viaja en esta época, asegúrese de que su resort tenga políticas de cancelación flexibles y protocolos de seguridad establecidos.",
        "q4": "¿Qué idiomas se hablan en los resorts del Caribe?",
        "a4": "La mayoría de los resorts del Caribe tienen personal multilingüe que habla español, inglés y portugués. En México, República Dominicana y Cuba el español es el idioma principal, mientras que en Jamaica y Aruba predomina el inglés.",
        "q5": "¿Los resorts del Caribe tienen actividades de snorkel y buceo?",
        "a5": "Sí, el Caribe es famoso por sus arrecifes de coral y vida marina. La mayoría de los resorts ofrecen snorkel gratuito y buceo con certificación disponible. Destinos como Cozumel, Aruba y las Islas Caimán son especialmente buenos para estas actividades."
      },
      "africa": {
        "q1": "¿Es posible combinar safari con playa en África?",
        "a1": "Sí, es una de las experiencias más populares. Puede combinar safari en Kenia o Tanzania con playas de Zanzíbar, o safari en Sudáfrica con resorts en Mauricio o Seychelles. Muchas agencias ofrecen paquetes que incluyen ambas experiencias.",
        "q2": "¿Cuáles son los mejores resorts de playa en África?",
        "a2": "Los mejores destinos de playa incluyen Mauricio, Seychelles, Zanzíbar, la costa de Kenia (Diani Beach), Hurghada y Sharm el-Sheikh en Egipto, y la costa de Mozambique. Cada uno ofrece experiencias únicas y resorts de lujo.",
        "q3": "¿Necesito vacunas para viajar a África?",
        "a3": "Depende del destino. Para Egipto y Mauricio generalmente no se requieren vacunas obligatorias. Para destinos de safari como Kenia y Tanzania, se recomienda la vacuna contra la fiebre amarilla. Consulte siempre con un médico especialista en medicina del viajero.",
        "q4": "¿Cuál es la mejor época para safari en África?",
        "a4": "La época seca (julio a octubre) es ideal para safaris en África Oriental, coincidiendo con la gran migración. Para Sudáfrica, los meses de invierno (mayo a septiembre) son mejores para avistar animales ya que la vegetación es menos densa.",
        "q5": "¿Los resorts de África son seguros?",
        "a5": "Sí, los resorts de lujo en África mantienen altos estándares de seguridad. Destinos como Mauricio, Seychelles y los resorts de Egipto tienen excelentes índices de seguridad. Para safaris, los lodges están diseñados para ofrecer experiencias seguras con la vida salvaje."
      },
      "europa": {
        "q1": "¿Cuáles son los mejores resorts all inclusive en Europa?",
        "a1": "Los destinos más populares incluyen las Islas Canarias (Tenerife, Gran Canaria), las Islas Baleares (Mallorca, Ibiza), las islas griegas (Creta, Rodas), la Riviera Turca (Antalya) y el Algarve portugués. Todos ofrecen excelentes opciones all inclusive.",
        "q2": "¿Los resorts europeos son más caros que los del Caribe?",
        "a2": "No necesariamente. Destinos como Turquía y las Islas Canarias ofrecen excelentes precios, a menudo comparables o mejores que el Caribe. Grecia y las Baleares pueden ser más costosos en temporada alta, pero ofrecen excelente relación calidad-precio.",
        "q3": "¿Cuándo es la mejor época para visitar resorts en el Mediterráneo?",
        "a3": "La temporada ideal va de mayo a octubre, con clima cálido y seco. Junio y septiembre son ideales para evitar multitudes y disfrutar de mejores precios. Las Islas Canarias son perfectas todo el año gracias a su clima subtropical.",
        "q4": "¿Los resorts europeos incluyen excursiones culturales?",
        "a4": "Muchos resorts ofrecen excursiones opcionales a sitios históricos y culturales cercanos. Puede visitar ruinas griegas desde Creta, ciudades históricas españolas desde las Baleares, o sitios romanos desde la costa turca. Algunas excursiones tienen costo adicional.",
        "q5": "¿Es necesario visa para ciudadanos latinoamericanos en Europa?",
        "a5": "Ciudadanos de la mayoría de países latinoamericanos pueden visitar el espacio Schengen (incluyendo España, Grecia, Portugal) sin visa por hasta 90 días. Para Turquía, algunos países requieren e-visa. Siempre verifique los requisitos específicos para su nacionalidad."
      },
      "outros": {
        "q1": "¿Cuánto cuesta un viaje a las Maldivas?",
        "a1": "Las Maldivas ofrecen opciones para diferentes presupuestos. Resorts de lujo cuestan desde $500-$2000+ por noche, mientras que guesthouses en islas locales pueden costar $100-200. Los paquetes all inclusive varían de $3000 a $15000+ por semana para dos personas.",
        "q2": "¿Cuál es la mejor época para visitar destinos exóticos?",
        "a2": "Varía según el destino: Maldivas (noviembre-abril), Tailandia (noviembre-febrero), Bali (abril-octubre), Dubái (octubre-abril). Cada destino tiene temporada de monzones o calor extremo que es mejor evitar.",
        "q3": "¿Es seguro viajar a destinos como Tailandia o Bali?",
        "a3": "Sí, Tailandia y Bali son destinos muy seguros para turistas. Tienen infraestructura turística desarrollada, personal que habla inglés, y comunidades internacionales establecidas. Como en cualquier viaje, se recomiendan precauciones básicas de seguridad.",
        "q4": "¿Qué incluyen los resorts de lujo en las Maldivas?",
        "a4": "Los resorts de Maldivas típicamente incluyen villa privada (muchas sobre el agua), todas las comidas y bebidas premium, snorkel y kayak, acceso a spa, excursiones de buceo, cenas privadas en la playa, y transfers en hidroavión o lancha rápida.",
        "q5": "¿Dubái es un buen destino para familias?",
        "a5": "Sí, Dubái es excelente para familias. Los mega-resorts ofrecen parques acuáticos, clubes infantiles, y están cerca de atracciones como Atlantis, Ferrari World, y los centros comerciales más grandes del mundo. El clima es ideal de octubre a abril."
      }
    }
  },
  "activities": {
    "breadcrumb": "Actividades",
    "title": "Actividades y Experiencias en Brasil",
    "subtitle": "Vive Brasil al máximo. Tours, aventuras, cultura y momentos inolvidables te esperan.",
    "searchPlaceholder": "¿Qué te gustaría hacer?",
    "searchAriaLabel": "Buscar actividades por nombre o tipo",
    "productType": "Actividades",
    "loading": "Cargando actividades...",
    "error": "Error al cargar actividades. Por favor, intenta de nuevo.",
    "showingResults": "Mostrando {{count}} actividades",
    "noResultsFiltered": "No se encontraron actividades con los filtros seleccionados. Intenta ajustar tus criterios de búsqueda.",
    "noResults": "No hay actividades disponibles en este momento.",
    "seo": {
      "title": "Actividades y Tours en Brasil | Experiencias Únicas",
      "description": "Descubre las mejores actividades y tours en Brasil. Aventuras, cultura, gastronomía y experiencias inolvidables. Reserva online con confirmación inmediata."
    },
    "seoContent": {
      "title": "Descubre las Mejores Experiencias en Brasil",
      "intro": "Brasil ofrece una increíble variedad de actividades y experiencias para todos los gustos. Desde aventuras emocionantes hasta inmersiones culturales, hay algo especial esperándote en cada rincón de este fascinante país.",
      "features": {
        "tours": {
          "title": "Tours y Excursiones",
          "description": "Explora los destinos más icónicos de Brasil con guías expertos locales. Desde el Cristo Redentor hasta la Amazonia, cada tour es una aventura única."
        },
        "culture": {
          "title": "Experiencias Culturales",
          "description": "Sumérgete en la rica cultura brasileña. Clases de samba, visitas a comunidades locales, talleres de capoeira y mucho más te esperan."
        },
        "gastronomy": {
          "title": "Gastronomía Brasileña",
          "description": "Degusta los sabores auténticos de Brasil. Tours gastronómicos, clases de cocina y experiencias culinarias que deleitarán tu paladar."
        },
        "nightlife": {
          "title": "Vida Nocturna",
          "description": "Vive la famosa vida nocturna brasileña. Shows de samba, bares tradicionales y la energía única de las noches de Río y São Paulo."
        }
      },
      "whyBookTitle": "¿Por Qué Reservar con Nosotros?",
      "whyBookText": "Ofrecemos una cuidada selección de las mejores actividades en Brasil, con confirmación inmediata, cancelación flexible y los mejores precios garantizados. Nuestros partners locales son expertos certificados que garantizan experiencias seguras y memorables. Además, nuestro equipo de atención al cliente está disponible en español para ayudarte antes, durante y después de tu viaje.",
      "destinationsTitle": "Destinos Principales para Actividades",
      "destinationsText": "Río de Janeiro destaca con tours al Pan de Azúcar, el Cristo Redentor y paseos por las favelas. Salvador ofrece inmersiones en la cultura afrobrasileña y clases de capoeira. Foz do Iguaçu permite aventuras en las cataratas más impresionantes del mundo. El Pantanal y la Amazonia son perfectos para safaris ecológicos y observación de fauna. Fernando de Noronha es el paraíso para el buceo y snorkel."
    }
  },
  "cars": {
    "breadcrumb": "Coches",
    "title": "Alquiler de Coches en Brasil",
    "subtitle": "Explora Brasil con total libertad. Amplia selección de vehículos para cada tipo de viaje.",
    "searchPlaceholder": "Ciudad de recogida",
    "searchAriaLabel": "Buscar coches por ciudad",
    "productType": "Coches",
    "loading": "Cargando coches...",
    "error": "Error al cargar coches. Por favor, intenta de nuevo.",
    "showingResults": "Mostrando {{count}} coches",
    "noResultsFiltered": "No se encontraron coches con los filtros seleccionados. Intenta ajustar tus criterios de búsqueda.",
    "noResults": "No hay coches disponibles en este momento.",
    "seo": {
      "title": "Alquiler de Coches en Brasil | Mejores Precios",
      "description": "Alquila coches en Brasil con los mejores precios. Recogida en aeropuertos, seguro incluido y atención en español. Reserva online ahora."
    },
    "seoContent": {
      "title": "Alquiler de Vehículos en Brasil",
      "intro": "Descubre la libertad de explorar Brasil a tu ritmo. Con nuestra amplia flota de vehículos, desde económicos hasta SUVs de lujo, tienes la opción perfecta para cada aventura.",
      "features": {
        "variety": {
          "title": "Amplia Variedad de Vehículos",
          "description": "Desde coches compactos ideales para la ciudad hasta SUVs potentes para aventuras off-road. Encuentra el vehículo perfecto para tu viaje."
        },
        "insurance": {
          "title": "Seguro Completo Incluido",
          "description": "Todos nuestros alquileres incluyen seguro básico. Opciones de cobertura total disponibles para mayor tranquilidad durante tu viaje."
        },
        "locations": {
          "title": "Múltiples Puntos de Recogida",
          "description": "Recoge y devuelve tu coche en los principales aeropuertos y ciudades de Brasil. Máxima comodidad para tu itinerario."
        },
        "flexibility": {
          "title": "Flexibilidad Total",
          "description": "Modificación y cancelación gratuita hasta 48 horas antes. Sin sorpresas ni cargos ocultos en tu reserva."
        }
      },
      "whyRentTitle": "¿Por Qué Alquilar un Coche en Brasil?",
      "whyRentText": "Brasil es un país de dimensiones continentales con paisajes increíblemente diversos. Alquilar un coche te permite explorar a tu propio ritmo, descubrir playas escondidas, visitar pequeños pueblos con encanto y escapar de las rutas turísticas masificadas. Desde la Costa Verde de Río de Janeiro hasta las playas del Nordeste, pasando por la Ruta Romántica de Río Grande do Sul, hay rutas espectaculares esperándote.",
      "tipsTitle": "Consejos para Conducir en Brasil",
      "tipsText": "Las principales autopistas brasileñas están bien mantenidas y señalizadas. Recomendamos contratar GPS o usar apps de navegación. El tráfico en grandes ciudades como São Paulo y Río puede ser intenso, especialmente en hora punta. Para rutas costeras y destinos de playa, un coche con aire acondicionado es esencial. Si planeas visitar el Pantanal o áreas rurales, considera un vehículo con tracción 4x4."
    }
  }
}